import { accessObjectViaString } from './helpers';

export const sortTruthy = (array, truthyIndex) => {
  array.sort(item => (item[truthyIndex]) ? -1 : 1); // eslint-disable-line
};

// const sortNumbers = (first, second, type) => {
//   if (first < second) {
//     return (type === 'desc') ? -1 : 1;
//   }
//   if (first > second) {
//     return (type === 'desc') ? 1 : -1;
//   }
//   return 0;
// };

// const sortStrings = (first, second, type) => {
//   if (type === 'desc') {
//     return second.localeCompare(first);
//   }
//   return first.localeCompare(second);
// };

const sortComparison = (first, second, type, replaceNull = null) => {
  const auxFirst = replaceNull || first,
    auxSecond = replaceNull || second;

  if (auxFirst < auxSecond) {
    return (type === 'desc') ? -1 : 1;
  }
  if (auxFirst > auxSecond) {
    return (type === 'desc') ? 1 : -1;
  }
  return 0;
};

const extractSortableData = (data) => {
  const castDataToNumber = Number(data);
  if (isNaN(castDataToNumber)) {
    if (typeof data === 'string') {
      return (data.indexOf(';') !== -1) ?
        data.replace(/[0-9:,;]/g, '').toLowerCase() :
        data.toLowerCase();
    }
    return data;
  }
  return castDataToNumber;
};

export const sortTableColumn = (array, sortObject, replaceNull = null) => {
  const type = sortObject.type;
  if (sortObject && typeof sortObject === 'object') {
    array.sort((a, b) => {
      const index = sortObject.name,
        first = extractSortableData(accessObjectViaString(a, index)),
        second = extractSortableData(accessObjectViaString(b, index));

      return sortComparison(first, second, type, replaceNull);
    });
  }
};



// WEBPACK FOOTER //
// ./src/common/functions/sort.js